import { replacePII } from '@wix/wix-chatbot-common/utils';

import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ErrorMessagePresentedBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotErrorMessagePresented: BiEventLogger<ErrorMessagePresentedBiData> = async (
  state,
  data,
) => {
  const biData = selectBiData(state);
  const { conversationId = '', nodeId } = biData;
  const { sessionId = '', contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotErrorMessagePresented({
    conversation_id: conversationId,
    node_id: nodeId,
    session_id: sessionId,
    chatbot_view: contextBi?.chatbot_view,
    message_id: data.messageId,
    user_message: replacePII(data.messageText),
    lang: locale,
    button_name: data.buttonName,
    is_button_exist: data.isTryAgainAvailable,
    error_type: data.errorType,
    extra_fields: undefined,
  });
};
